(function (window, undefined) {
  'use strict';
  var scripts = document.getElementsByTagName('script');
  var baseRoot = 'CBL-INSURANCELOANPMI-MF';
  for (var el in scripts) {
    if (scripts[el].src && scripts[el].src.indexOf('INSURANCELOANPMI') > -1) {
      baseRoot = scripts[el].src.split('/')[3];
    }
  }
  angular.module('cbl.insuranceloanpmi.mf').constant('CONSTANTS', {
    BASE_ROOT: '/' + baseRoot + '/app/',
    REST_ROOT: '/' + baseRoot + '/services/api-',
    REST_CLIENTI_ROOT: '/MSF-PROSPECTMANAGER-MF/api/',
    COMPONENTS_PATH: 'components/',

    FUNA: {},

    REST: {
      GENERAL: {
        LABEL: 'generale/label',
        FUNA: 'generale/funa',
        TAB: 'generale/tab',
        USER: 'generale/utente',
        LOG: 'generale/log',
        DOMAIN: 'generale/dominio',
        FIELDCONFIGURATOR: 'generale/fieldConfigurator',
      },
      CLIENTI: {
        DETTAGLIO: 'cliente/cliente/',
        DETTAGLIO_CERCA: 'cliente/cliente/dettaglio',
        DETTAGLIO_INTEGRAZIONE: 'cliente/cliente/integrazione',
        RICERCA: {
          BANCA: 'cliente/cliente/ricerca/banca',
          CERVED: 'cliente/cliente/ricerca/cerved',
        },
        INTEGRAZIONE: {
          CLIENTE: 'cliente/cliente/integrazione',
          FIRMATARI: 'cliente/cliente/firmatari/integrazione',
        },
        CREA_DA_CERVED: 'cliente/cliente/ricerca/creaDaCerved',
      },
      PRATICHE: {
        RICERCA: 'pratica/cerca',
        DETTAGLIO: 'pratica/pratiche/',
      },
      AFFIDAMENTI: {
        FIDO: 'fido/fidi/',
        FIDOPERNDG: 'fido/fidi/ndg/',
      },
      DETTAGLIO_CONTO: 'fido/dettaglioConto',
      FASCEAFFIDAMENTO: 'fascia-affidamento/fasce',
      CONVENZIONI: 'convenzione/convenzioni',
      TITOLI: 'finanziamenti/titoli',
      FINANZIAMENTI: 'finanziamenti/finanziamenti',
      PERSONAFISICA: {
        ACCETTA: 'NaturalPerson/Accept',
        ACCETTASENZAWCL: 'NaturalPerson/AcceptWithoutWcl',
      },
      PERSONAGIURIDICA: {
        ACCETTA: 'LegalPerson/Accept',
        ACCETTASENZAWCL: 'LegalPerson/AcceptWithoutWcl',
      },
    },

    STATI_PRATICA: [
      'BOZZA',
      'INCORSO',
      'VALUTAZIONE',
      'DEFINITA',
      'CONSOLIDATA',
      'GESTIONEPOLIZZE',
      'INTEGRAZIONE',
    ],
  });
})(window);



//////////////////
// WEBPACK FOOTER
// ./app/app.constants.js
// module id = 2
// module chunks = 0 1